import React, { Component, Fragment } from 'react';
import { Link } from 'react-router';
import { Row, Col, Popover, PopoverBody } from 'reactstrap';
import { CtrTableHd } from '../../../contracts/Elements/';
import Select from 'react-select'
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { getLocalStorageInfo } from '../../../../utils';
import { toastFlashMessage, showCurrencyFormat } from '../../../../utils';
import { FieldCol, FieldGroup, FieldLabel, FieldTextarea, FieldSelect, FieldInput, FieldDate, FieldDateIndex } from '../../Elements';
import { pbhRangeCondition, currencyList, rentalTypeDropdown, intervalDropdown, escalationIntervalDropdwn, fieldDateFormat, imgStoragePath, securityGroups, displayDateFormat, backendDateFormat, days, roundOffTypes, months, displayDateTimeFormatShort, displayDateFormatShort, displayDateTimeFormat } from '../../../../constants'
import { checkString, checkValidDate, checkNumber, checkDateDiff } from '../../../../formValidator';
import { Tooltip,Button, Typography, Switch } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { getRentalAccountTypeApi } from '../../MRRates/apiServices';
import { jetStreamInstance } from '../../../../lease_management/Leases';
import { globalDownloadService } from '../../../../utils_v2/globalApiServices';
import { downloadFileType } from '../../../../utils_v2';
import { ImportModal } from '../../../../shared_elements';
import { avationPlcInstance, gaTelesisInstance, Lessor_test, titanInstance, mtInstance, leshaBankInstance } from '../../../../shared_elements/components';
const decimalRegex = /^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/;
const numericWithHyphen = /^[\d\-]+$/
const numberWithDot = /^[0-9]*(\.\d{0,2})?$/
const intRegx = /^[0-9]?\d+$/;

const CustomExportButton = ({ open, handleExport, disabled }) => {
  return (<Button
    // ref={anchorRef}
    aria-controls={open ? 'menu-list-grow' : undefined}
    aria-haspopup="true"
    onClick={handleExport}
    color="primary"
    disabled={disabled}
    variant="text"
    size='small'
  ><SaveAltIcon style={{fontSize: '1.15rem'}}/>Export
  </Button>
  )
}


export default class EditRentalForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leaseRental: {},
      sheetInfo: {},
      error: {},
      validationArray: {},
      pbh_condition_error: [],
      payToggleState: false,
      updateSheetFlag: false,
      fileSheet: '',
      paymentList: [{}, {}, {}, {}],
      adminFlag: false,
      contracterFlag: false,
      requireBanking: false,
      flight_hour_pbh: false,
      block_hour_pbh: false,
      flight_cycle_pbh: false,
      flight_hour_flexi: false,
      block_hour_flexi: false,
      flight_cycle_flexi: false,
      showLess: true,
      showGreat: true,
      errorRate: '',
      accType: [],
      chartAccInfo:[],
      productServiceInfo:[],
    }
    this.getRentalAccountTypeApi = getRentalAccountTypeApi.bind(this)  
  }
  componentDidMount() {
    let data = JSON.parse(JSON.stringify(this.props.rentalView));
    let dataSheet = JSON.parse(JSON.stringify(this.props.sheetInfo));
    delete data['rental_type'];
    delete data['rental_interval'];
    delete data['rental_escalation_interval'];
    delete data['lease_type'];
    delete data['lease_type_accounting'];
    let pbh_condition = []
    if (this.props.rentalView.pbh_condition && this.props.rentalView.pbh_condition.length) {
      this.props.rentalView.pbh_condition.map(condition => {
        if (this.props.rentalView.unit_of_measure && this.props.rentalView.unit_of_measure.value === 1) {
          pbh_condition.push({
            type: 1,
            min: condition.min,
            max: condition.max,
            ratio_range: condition.ratio_range,
            rate: condition.rate,
            rental_rate_type: condition.rental_rate_type,
            remarks: parseInt(condition.ratio_range) === 1 ? 'max' : parseInt(condition.ratio_range) === 6 ? 'min' : 'min,max'
          })
        } else if (this.props.rentalView.unit_of_measure && this.props.rentalView.unit_of_measure.value === 2) {
          pbh_condition.push({
            type: condition.type,
            min: condition.min,
            max: condition.max,
            ratio_range: condition.ratio_range,
            rate: condition.rate,
            rental_rate_type: condition.rental_rate_type,
            remarks: parseInt(condition.ratio_range) === 1 ? 'max' : parseInt(condition.ratio_range) === 6 ? 'min' : 'min,max'
          })
        } else if (this.props.rentalView.unit_of_measure && this.props.rentalView.unit_of_measure.value === 4) {
          pbh_condition.push({
            type: 4,
            min: condition.min,
            max: condition.max,
            ratio_range: condition.ratio_range,
            rate: condition.rate,
            rental_rate_type: condition.rental_rate_type,
            remarks: parseInt(condition.ratio_range) === 1 ? 'max' : parseInt(condition.ratio_range) === 6 ? 'min' : 'min,max'
          })
        } else if (this.props.rentalView.unit_of_measure && this.props.rentalView.unit_of_measure.value === 3) {
          pbh_condition.push({
            type: condition.type,
            min: condition.min,
            max: condition.max,
            ratio_range: condition.ratio_range,
            rate: condition.rate,
            rental_rate_type: condition.rental_rate_type,
            remarks: parseInt(condition.ratio_range) === 1 ? 'max' : parseInt(condition.ratio_range) === 6 ? 'min' : 'min,max'
          })
        } else if (this.props.rentalView.unit_of_measure && this.props.rentalView.unit_of_measure.value === 5) {
          pbh_condition.push({
            type: condition.type,
            min: condition.min,
            max: condition.max,
            ratio_range: condition.ratio_range,
            rate: condition.rate,
            rental_rate_type: condition.rental_rate_type,
            remarks: parseInt(condition.ratio_range) === 1 ? 'max' : parseInt(condition.ratio_range) === 6 ? 'min' : 'min,max'
          })
        }
      })
    }
    let majorAssembly = this.props.utilsMajorAssembly.find(assembly => assembly.asset_id == data.asset_id);
    data = {
      ...data,
      rental_type: this.props.rentalView.rental_type && this.props.rentalView.rental_type.value ? this.props.rentalView.rental_type.value : null,
      interval: this.props.rentalView.interval && this.props.rentalView.interval.value ? this.props.rentalView.interval.value : null,
      escalation_interval: this.props.rentalView.escalation_interval && this.props.rentalView.escalation_interval.value ? this.props.rentalView.escalation_interval.value : null,
      unit_of_measure: this.props.rentalView.unit_of_measure && this.props.rentalView.unit_of_measure.value ? this.props.rentalView.unit_of_measure.value : null,
      pbh_condition: pbh_condition,
      range_calculation_type: this.props.rentalView.range_calculation_type === true && this.props.rentalView.rental_type === 3 ? true : false,
      titan_extra_fields: {...data?.titan_extra_fields ,rates_per_30_days: data?.titan_extra_fields?.rates_per_30_days === false ? false : true },
      ...(jetStreamInstance ? {
        major_assembly: majorAssembly && majorAssembly.id ? majorAssembly.id : null,
        account_type: this.props.rentalView?.account_type ? this.props.rentalView?.account_type : null,
        rental_invoice_type: this.props.rentalView?.rental_invoice_type ? this.props.rentalView?.rental_invoice_type : { value: 1, label: "Advance" }
      } : {})
    }
    this.setState({
      leaseRental: data,
      sheetInfo: dataSheet
    });
    this.getRentalAccountTypeApi()
    if (this.props.type == 'edit') {
      this.setState({
        payToggleState: true
      })
    }
    if (data.account_type) {
      if (data.account_type.value == 1) {
        this.setState({ assetList: this.props.utilsMajorAssembly.filter(obj => obj.asset_type == '2') })
      } else {
        this.setState({ assetList: this.props.utilsMajorAssembly })
      }
    }
    this.props.rentalView.requested_data && Object.keys(this.props.rentalView.requested_data).length ?
      getLocalStorageInfo().user.is_root_user ?
        this.setState({
          adminFlag: true
        }) :
        getLocalStorageInfo().user.security_groups.filter(data => data.id == securityGroups.lessor_admin).length == 1 ?
          this.setState({
            adminFlag: true
          }) :
          this.setState({
            contracterFlag: true
          }) :
      this.setState({
        contracterFlag: false,
        adminFlag: false
      })


  }

  capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.sheetInfo != nextProps.sheetInfo) {
      this.updateSheetState(nextProps.sheetInfo)
    }
    if (this.props.type != nextProps.type) {
      if (nextProps.type == 'edit') {
        this.setState({
          payToggleState: true
        })
      }
    }
  }

  updateSheetState = (sheetInfo) => {
    this.setState({
      sheetInfo: sheetInfo
    });
  }

  addRatio = (unit_of_measure) => {
    this.setState(prevState => ({
      ...prevState,
      leaseRental: {
        ...prevState.leaseRental,
        pbh_condition: [
          ...prevState.leaseRental.pbh_condition,
          {
            type: unit_of_measure,
            min: 0,
            max: 0,
            ratio_range: '',
            rate: '1',
            rental_rate_type: 1,
            remarks: ''
          }
        ]
      },
    }))
  }

  addFlexiRatio = (unit_of_measure, type) => {
    this.setState(prevState => ({
      ...prevState,
      pbh_condition_error: [...prevState.pbh_condition_error, { min: '', max: '', index: prevState.pbh_condition_error.length }],
      leaseRental: {
        ...prevState.leaseRental,
        pbh_condition: [
          ...prevState.leaseRental.pbh_condition,
          {
            type: unit_of_measure,
            min: 0,
            max: 0,
            ratio_range: type === 'range' ? '4' : type === 'min' ? '6' : '1',
            rate: 0,
            rental_rate_type: type !== 'range' ? 1 : 2,
            remarks: type !== 'range' ? type : 'min,max'
          }
        ]
      },
    }))
  }

  updateRangeConditon = (key, value, index) => {
    if (key === 'ratio_range') {
      let condition = {
        1: 'max',
        6: 'min',
        4: 'min,max'
      }
      let dynamicValue = ''
      if (value === 1) {
        this.setState(prevState => ({
          ...prevState,
          leaseRental: {
            ...prevState.leaseRental,
            pbh_condition: prevState.leaseRental.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value, remarks: condition[value], max: 0, min: 0 } : range)
          },
        }))
      } else if (value === 6) {
        this.setState(prevState => ({
          ...prevState,
          leaseRental: {
            ...prevState.leaseRental,
            pbh_condition: prevState.leaseRental.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value, remarks: condition[value], min: 0, max: 0 } : range)
          },
        }))
      } else {
        this.setState(prevState => ({
          ...prevState,
          leaseRental: {
            ...prevState.leaseRental,
            pbh_condition: prevState.leaseRental.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value, remarks: condition[value], min: 0, max: 0 } : range)
          },
        }))
      }
      setTimeout(() => {
        if (this.state.leaseRental.rental_type === 4 || this.state.leaseRental.rental_type === 5) {
          if (this.state.leaseRental.pbh_condition.filter(item => item.ratio_range === 1).length) {
            this.setState({
              showLess: false
            })
          }
          if (this.state.leaseRental.pbh_condition.filter(item => item.ratio_range === 6).length) {
            this.setState({
              showGreat: false
            })
          }
        }
      })
    } else {
      this.setState(prevState => ({
        ...prevState,
        leaseRental: {
          ...prevState.leaseRental,
          pbh_condition: prevState.leaseRental.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value } : range)
        },
      }))
    }
    this.setState(prevState => ({
      ...prevState,
      pbh_condition_error: prevState.pbh_condition_error.map(conError => {
        if (conError.index === index) {
          return { ...conError, [key]: '' }
        } else {
          return conError
        }
      })
    }))
  }

  removeRatio = (index) => {
    this.setState(prevState => ({
      ...prevState,
      leaseRental: {
        ...prevState.leaseRental,
        pbh_condition: prevState.leaseRental.pbh_condition.filter((range, rangeIndex) => index !== rangeIndex)
      },
    }))
  }
  updateForm = (type, value) => {
    this.setState(prevState => ({
      ...prevState,
      leaseRental: {
        ...prevState.leaseRental,
        [type]: value
      },
      error: {
        ...prevState.error,
        [type]: ''
      }
    }), () => {
      let flag = false;
      ['bank_code', 'bank_iban', 'bank_name', 'bank_note', 'bank_reference', 'bank_sort_code', 'bank_account_name', 'bank_account_number', 'bank_swift_code', 'aba_bumber'].map(key => {
        if (this.state.leaseRental[key] !== '' && this.state.leaseRental[key] != null) {
          flag = true
        }
      })
      this.setState({
        requireBanking: flag
      })
    })
    // if(type === 'start_date' && (value === '' || value === null)){
    //   this.setState(prevState => ({
    //     ...prevState,
    //     leaseRental: {
    //       ...prevState.leaseRental,
    //       end_date: ''
    //     }
    //   }))
    // }
    // if(type=='end_date'){
    //   this.setState(prevState => ({
    //     ...prevState,
    //     error: {
    //       ...prevState.error,
    //       [type]: checkDateDiff({value:this.state.leaseRental.end_date,required:true},{value:value,required:true})
    //     }
    //   }))
    // }
    if (type == 'rental_type') {
      this.setState(prevState => ({
        ...prevState,
        pbh_condition_error: [],
        leaseRental: {
          ...prevState.leaseRental,
          unit_of_measure: value === 5 ? 5 : prevState.leaseRental.unit_of_measure,
          pbh_condition: []
        },
        pbh_condition_error: [],
        error: { ...prevState.error, rate: "" }
      }))
      if(value === 2){
        this.setState({ sheetInfo: [],})
      }
      if (value!== 1) {
        this.setState(prevState => ({
          leaseRental: {
            ...prevState.leaseRental,
            interval: value ==6? 1:null
          }
        }))}
    }
    if(type ==='escalation_interval' && value ==2 ){
      this.setState(prevState=>({
        ...prevState, leaseRental:{
          ...prevState.leaseRental,
          escalation_start_date: moment(this.props?.rentalInfoDetails?.contract_rental_details?.contractual_start_date).add(1,'years').format(backendDateFormat)
        }
      }))
    }
    if (type === 'unit_of_measure') {
      this.setState(prevState => ({
        ...prevState,
        leaseRental: {
          ...prevState.leaseRental,
          pbh_condition: []
        },
        pbh_condition_error: [],
        error: {
          ...prevState.error,
          pbh_condition: [],
          rate: ''
        }
      }))
    }
    if (type === 'account_type' && jetStreamInstance) {
      if (value?.value === 1) {
        this.setState({ assetList: this.props.utilsMajorAssembly.filter(obj => obj.asset_type == '2') })
      } else {
        this.setState({ assetList: this.props.utilsMajorAssembly })
      }
      this.setState(prevState => ({
        ...prevState,
        leaseRental: {
          ...prevState.leaseRental,
          account_type: value ? value : 0 , 
        }
      }))
    } 
    if (type === 'qb_chart_of_account') {
      this.setState(prevState => ({
        ...prevState,
        leaseRental: {
          ...prevState.leaseRental,
          qb_chart_of_account: value ? value : null 
        }
      }))
    }     
    if (type == 'rental_invoice_type' && jetStreamInstance) {
      this.setState(prevState => ({ ...prevState, leaseRental: { ...prevState.leaseRental, rental_invoice_type: value, interval: null } }))
    } 
    if (type == 'major_assembly' && jetStreamInstance) {
      let asset_id = '';
      let asset_type = '';
      if (value) {
        let asset = this.props.utilsMajorAssembly.filter(assembly => assembly.id == value);
        asset_id = asset[0].asset_id;
        asset_type = asset[0].asset_type;
      }
      this.setState(prevState => ({ ...prevState, leaseRental: { ...prevState.leaseRental, asset_id: asset_id, asset_type: asset_type, major_assembly: value },
      error: { ...prevState.error, [type]: '' }
      }))
    }  
    let data= Object.assign({},this.state.leaseRental)
    if (this.state.leaseRental.max_cap_applicable) {
      data.max_cap_amount = parseFloat(this.state.leaseRental.max_cap_amount || null);
    } else {
      data.max_cap_amount = null; 
    }
  }
  updateTitanFields =(type, value)=>{
    this.setState(prevState=>{
      let startDate = prevState.leaseRental?.titan_extra_fields?.rental_start_date
      let endDate = prevState.leaseRental?.titan_extra_fields?.rental_end_date
      let perDayRent = prevState.leaseRental?.titan_extra_fields?.rental_rate_per_day
      let monthlyRate =prevState.leaseRental.titan_extra_fields?.monthly_rate ?parseFloat(prevState.leaseRental.titan_extra_fields?.monthly_rate) : 0
      let rentalMonth =prevState.leaseRental.titan_extra_fields?.rental_month
      let noOfDays =prevState.leaseRental.titan_extra_fields?.no_of_days ? parseFloat(prevState.leaseRental.titan_extra_fields?.no_of_days) :''

      const updatedFields ={
        ...prevState.leaseRental.titan_extra_fields,
        [type]:value
      }
      if(type =='rates_per_30_days'){
        let monthDays = value === true ? 30 : rentalMonth ? moment(rentalMonth).daysInMonth():30
        updatedFields['rental_rate_per_day'] = value == false 
        ?rentalMonth && monthlyRate ? parseFloat(parseFloat(monthlyRate) /moment(rentalMonth).daysInMonth()).toFixed(2) :0: 
        (monthlyRate ? (parseFloat(monthlyRate)/30).toFixed(2):0) ;
        updatedFields['prorated_rental_amount']= noOfDays && monthlyRate ? ((monthlyRate/ monthDays) * noOfDays).toFixed(2) :''
      }
      else if(type ==='monthly_rate'){
        this.updateForm('amount', value)
        let days = prevState.leaseRental.titan_extra_fields?.rates_per_30_days ? 30 : moment(rentalMonth).daysInMonth()
        updatedFields['rental_rate_per_day']= (parseFloat(value || 0) / parseFloat(days || 0)).toFixed(2)
        updatedFields['prorated_rental_amount']= noOfDays && value? ((parseFloat(value || 0) / parseFloat(days || 0)) * noOfDays).toFixed(2) :''
      }
      else if (type ==='rental_month' && monthlyRate ){
        let days = prevState.leaseRental.titan_extra_fields?.rates_per_30_days ? 30 : moment(value).daysInMonth()
        updatedFields['rental_rate_per_day']= (monthlyRate / parseFloat(days)).toFixed(2)
        updatedFields['prorated_rental_amount']= monthlyRate&&days && noOfDays? ((monthlyRate/ days) * noOfDays).toFixed(2):''
      }
      else if(type =='rental_end_date'){
        this.updateForm('end_date', value)
        if(startDate){
          let totalDays =value? moment(value).diff(moment(startDate), 'days') +1: 0
          updatedFields['no_of_days']= totalDays
          updatedFields['prorated_rental_amount']= (totalDays * perDayRent).toFixed(2)
        }
      }
      else if( type =='rental_start_date'){
        this.updateForm('start_date', value)
        if(endDate){
        let totalDays = value ? moment(endDate).diff(moment(value),'days')+1:0
        updatedFields['no_of_days']= totalDays
        updatedFields['prorated_rental_amount']= (totalDays * perDayRent).toFixed(2)
        }
      }
      return{
        ...prevState,
        leaseRental:{
          ...prevState.leaseRental,
          titan_extra_fields:updatedFields
        },
        error:{
          ...prevState.error,
          [type]:''
        }
      }
    })
  }
  
  updateEditedForm = (type, value) => {

    this.setState(prevState => ({
      ...prevState,
      leaseRental: {
        ...prevState.leaseRental,
        requested_data: {
          ...prevState.leaseRental.requested_data,
          [type]: value
        }
      }
    }))
  }
  checkmap = () => {
    let vaildArray = [];
    this.state.sheetInfo.map((item, index) => {
      let obj = {};
      if (decimalRegex.test(item.period)) {
        obj.period = true;
      } else {
        obj.period = true;
      }
      if (checkValidDate({ value: item.payment_date, required: true, minLength: '', maxLength: '', message: 'Please Select The Start Date' }) == '') {
        obj.payment_date = true;
      } else {
        obj.payment_date = false;
      }
      if (decimalRegex.test(item.reference_value)) {
        obj.reference_value = true;
      } else {
        obj.reference_value = false;
      }
      if (decimalRegex.test(item.rent)) {
        obj.rent = true;
      } else {
        obj.rent = false;
      }
      vaildArray.push(obj)
    })
    return vaildArray;
  }
  checkmapDates = (position) => {
    let vaildArray = [];
    this.state.sheetInfo.map((item, index) => {
      let obj = {};
      if (decimalRegex.test(item.period)) {
        obj.period = true;
      } else {
        obj.period = true;
      }
      if (position == index) {
        obj.payment_date = false;
      } else {
        if (checkValidDate({ value: item.payment_date, required: true, minLength: '', maxLength: '', message: 'Please Select The Start Date' }) == '') {
          obj.payment_date = true;
        } else {
          obj.payment_date = false;
        }
      }
      if (decimalRegex.test(item.reference_value)) {
        obj.reference_value = true;
      } else {
        obj.reference_value = false;
      }
      if (decimalRegex.test(item.rent)) {
        obj.rent = true;
      } else {
        obj.rent = false;
      }

      vaildArray.push(obj)
    })

    this.setState({
      validationArray: vaildArray
    });
  }
  updateSheetTable = (type, value, index) => {
    if (type == 'payment_date') {
      if (checkValidDate({ value: value, required: true, minLength: '', maxLength: '', message: 'Please Enter The End Date' }) == '') {
        if (index > 0 && index != (this.state.sheetInfo.length - 1)) {
          let days1 = moment(value).diff(moment(this.state.sheetInfo[index - 1].payment_date), 'days');
          let days2 = moment(this.state.sheetInfo[index + 1].payment_date).diff(moment(value), 'days');
          if (days1 > 0) {
            this.updateSheetPeriod('period', days1, index);
          } else {
            this.updateSheetPeriod('period', 0, index);
            this.checkmapDates(index);
          }
          if (days2 > 0) {
            this.updateSheetPeriod('period', days2, index + 1);
          } else {
            this.updateSheetPeriod('period', 0, index + 1);
            this.checkmapDates(index);
          }
        }
        if (index == 0 && this.state.sheetInfo.length > 1) {
          let days2 = moment(this.state.sheetInfo[index + 1].payment_date).diff(moment(value), 'days');
          if (days2 > 0) {
            this.updateSheetPeriod('period', days2, index + 1);
          } else {
            this.updateSheetPeriod('period', 0, index + 1);
            this.checkmapDates(index);
          }
        }
        if (index == (this.state.sheetInfo.length - 1) && this.state.sheetInfo.length > 1) {
          let days1 = moment(value).diff(moment(this.state.sheetInfo[index - 1].payment_date), 'days');
          if (days1 > 0) {
            this.updateSheetPeriod('period', days1, index);
          } else {
            this.updateSheetPeriod('period', 0, index);
            this.checkmapDates(index);
          }
        }
      }
    }
    this.setState(prevState => ({
      ...prevState,
      sheetInfo: prevState.sheetInfo.map((info, infoIndex) => infoIndex == index ? { ...info, [type]: value } : info),

    }))
  }

  updateSheetPeriod = (type, value, index) => {
    this.setState(prevState => ({
      ...prevState,
      sheetInfo: prevState.sheetInfo.map((info, infoIndex) => infoIndex == index ? { ...info, [type]: value } : info),

    }))

  }
  editPayment = () => {
    this.setState({
      payToggleState: !this.state.payToggleState
    });
  }

  updateRentalCustomLease = (check = false, flag) => {

    let data = Object.assign({}, this.state.leaseRental);
    data = {
      ...data,
      path: this.props.path,
      rental_payment_schedule: this.state.sheetInfo
    }
    if (check) {
      data = {
        ...data,
        change_request: flag ? 1 : 2
      }
      if (flag == 1) {
        this.props.addEditLeaseRental(data, this.props.type);
      } else {
        this.props.toggleReason(data, true, this.props.type);
      }

    } else {
      this.props.addEditLeaseRental(data, this.props.type);
    }


  }

  updatePdf = (sheet) => {
    if (sheet.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.setState({
        updateSheetFlag: true,
        fileSheet: sheet
      });
      this.uploadPdf(sheet);
    } else {
      toastFlashMessage('Please add proper sheet format file', 'error');
    }
  }

  uploadPdf = (sheet) => {
    var formData = new FormData();
    formData.append("file", sheet);
    formData.append("currency", this.state.leaseRental.currency);
    this.props.updateSheet(formData);
  }

  updateRental = (e) => {
    e.preventDefault();
    let validArray = [];
    var leaseRental = this.state.leaseRental;
    let startDate = gaTelesisInstance && leaseRental.rental_type == 6 ? leaseRental?.titan_extra_fields?.rental_start_date :leaseRental.start_date
    let endDate = gaTelesisInstance && leaseRental.rental_type == 6 ? leaseRental?.titan_extra_fields?.rental_end_date :leaseRental.end_date
    let pbh_condition_error = this.state.pbh_condition_error
    let validateNewInput = {
      max_cap_amount:(checkNumber({ value: this.state.leaseRental.max_cap_amount, required:this.state.leaseRental?.max_cap_applicable === true?true:false, minLength: '', maxLength: '', message: 'Please Enter Max Cap Amount' })),
      currency: leaseRental?.currency?.trim()?.trim()?.length ? '':'Please select Currency',
      rental_type: checkString({ value: leaseRental.rental_type, required: true, minLength: '', maxLength: '', message: 'Please Select The Rental Type' }),
      margin: checkString({ value: leaseRental.margin, required: leaseRental.rental_type == 2 ? leaseRental.is_additional_rate ? true : false : false, minLength: '', maxLength: '', message: 'Please Select The Dollar Margin Rate' }),
      interval:gaTelesisInstance && leaseRental.rental_type == 6 ?'': checkString({ value: leaseRental.interval, required: leaseRental.rental_type == 2 || leaseRental.rental_type === 3 || leaseRental.rental_type === 4 || leaseRental.rental_type == 5 ? false : true, minLength: '', maxLength: '', message: 'Please Select The Interval' }),
      amount:gaTelesisInstance && leaseRental.rental_type == 6 ?'': checkString({ value: leaseRental.amount, required: leaseRental.rental_type == 2 || leaseRental.rental_type == 4 || leaseRental.rental_type == 3 || leaseRental.rental_type == 5 ? false : true, minLength: '', maxLength: '', message: 'Please Enter The Amount' }),
      start_date: checkValidDate({ value: startDate , required: true, minLength: '', maxLength: '', message: 'Please Select The Start Date' }),
      end_date: moment(endDate).diff(moment(startDate), 'days') < (gaTelesisInstance && leaseRental.rental_type == 6? 0:1) ? 'Rental End Date can not be on or before Rental Start Date' : checkValidDate({ value: endDate, required: true, minLength: '', maxLength: '', message:this.props.rentalInfoDetails.contract_rental_details?.lease_duration_type?.value != 3 ? 'Please Enter The End Date':'' }),
      qb_chart_of_account :checkString({ value: leaseRental.qb_chart_of_account, required: jetStreamInstance? true:false, minLength: '', maxLength: '', message: 'Please Select Chart of Account' }),
      rental_rate_name : checkString({ value: leaseRental.rental_rate_name, required: jetStreamInstance? true:false, minLength: '', maxLength: '', message: 'Please Enter Rental Account Name' }), 
      qb_product_and_service :checkString({ value: leaseRental.qb_product_and_service, required: jetStreamInstance? true:false, minLength: '', maxLength: '', message: 'Please Select Product and Service' }), 
      escalation_start_date: !mtInstance && leaseRental?.escalation_start_date && !(moment(leaseRental?.escalation_start_date).isSameOrAfter(moment(leaseRental?.start_date)) && moment(leaseRental?.escalation_start_date).isSameOrBefore(moment(leaseRental?.end_date))) ? `Escalation Start Date should be between Rental Rate Start Date (${moment(leaseRental?.start_date).format(displayDateTimeFormat)}) and Rental Rate End Date (${moment(leaseRental?.end_date).format(displayDateTimeFormat)}).` : '',
      major_assembly: checkString({ value: leaseRental?.major_assembly, required: jetStreamInstance ? true : false, minLength: '', maxLength: '', message: 'Please Select Asset' }),
      account_type : checkString({ value: leaseRental?.account_type, required: jetStreamInstance ? true : false, minLength: '', maxLength: '', message: 'Please Select Account Type' }),
    };
    if (leaseRental.pbh_condition && leaseRental.pbh_condition.length) {
      if (this.state.error.rate || leaseRental.pbh_condition.filter(condition => condition.rate === 0 || condition.rate === '').length) {
        if (this.state.error.rate != '' || this.state.error.rate != undefined || this.state.error.rate != null) {
          validateNewInput = {
            ...validateNewInput,
            rate: 'Please enter Rate greater than 0'
          }
        }
      }

    }
    if (leaseRental.rental_type === 3 || leaseRental.rental_type === 4 || leaseRental.rental_type === 5) {
      validateNewInput = {
        ...validateNewInput,
        unit_of_measure: typeof leaseRental.unit_of_measure !== 'number' ? "Please select unit of measure" : '',
        pbh_condition: leaseRental.pbh_condition.length > 0 ? '' : 'Please add atleast one condition'
      }
    }
    if ([3, 4, 5].includes(parseInt(leaseRental.rental_type))) {
      if (leaseRental.rental_type === 5) {
        validateNewInput = {
          ...validateNewInput,
          pbh_condition: (leaseRental.pbh_condition.filter(rCond => rCond.type === 1).length) && (leaseRental.pbh_condition.filter(rCond => rCond.type === 2).length) ? '' : 'Please add atleast one condition in both Flight Hours and Flight Cycles'
        }
      }
      this.state.leaseRental.pbh_condition.map((con, conIndex) => {
        if (con.type === 2) {
          if (con.remarks === 'min' && (con.min === '' || con.min === null)) {
            pbh_condition_error = pbh_condition_error.map(conError => {
              if (conError.index === conIndex) {
                return { ...conError, min: 'Please Enter Min Value Greater Than 0' }
              } else {
                return conError
              }
            })
          } else if (con.remarks === 'max' && (con.max === '' || con.max === null)) {
            pbh_condition_error = pbh_condition_error.map(conError => {
              if (conError.index === conIndex) {
                return { ...conError, max: 'Please Enter Max Value Greater Than 0' }
              } else {
                return conError
              }
            })
          } else if (con.remarks === 'min,max') {
            if (con.min === '' || con.min === null) {
              pbh_condition_error = pbh_condition_error.map(conError => {
                if (conError.index === conIndex) {
                  return { ...conError, min: 'Please Enter Min Value Greater Than 0' }
                } else {
                  return conError
                }
              })
            }
            if (con.max === '' || con.max === null) {
              pbh_condition_error = pbh_condition_error.map(conError => {
                if (conError.index === conIndex) {
                  return { ...conError, max: 'Please Enter Max Value Greater Than 0' }
                } else {
                  return conError
                }
              })
            } else if (parseInt(con.max) <= parseInt(con.min)) {
              pbh_condition_error = pbh_condition_error.map(conError => {
                if (conError.index === conIndex) {
                  return { ...conError, max: 'Please Enter Max Value Greater Than Min Value' }
                } else {
                  return conError
                }
              })
            }
          } else if (parseFloat(con.max) > 2880) {
            pbh_condition_error = pbh_condition_error.map(conError => {
              if (conError.index === conIndex) {
                return { ...conError, max: 'Maximum Cycles Allowed Per Month is 2880' }
              } else {
                return conError
              }
            })
          }
        }
        if ([1, 4].includes(parseInt(con.type))) {
          if (con.remarks === 'min' && (con.min === '' || con.min === null)) {
            pbh_condition_error = pbh_condition_error.map(conError => {
              if (conError.index === conIndex) {
                return { ...conError, min: 'Please Enter Min Value Greater Than 0' }
              } else {
                return conError
              }
            })
          } else if (con.remarks === 'max' && (con.max === '' || con.max === null)) {
            pbh_condition_error = pbh_condition_error.map(conError => {
              if (conError.index === conIndex) {
                return { ...conError, max: 'Please Enter Max Value Greater Than 0' }
              } else {
                return conError
              }
            })
          } else if (con.remarks === 'min,max') {
            if (con.min === '' || con.min === null) {
              pbh_condition_error = pbh_condition_error.map(conError => {
                if (conError.index === conIndex) {
                  return { ...conError, min: 'Please Enter Min Value Greater Than 0' }
                } else {
                  return conError
                }
              })
            }
            if (con.max === '' || con.max === null) {
              pbh_condition_error = pbh_condition_error.map(conError => {
                if (conError.index === conIndex) {
                  return { ...conError, max: 'Please Enter Max Value Greater Than 0' }
                } else {
                  return conError
                }
              })
            } else if (parseFloat(con.max) <= parseFloat(con.min)) {
              pbh_condition_error = pbh_condition_error.map(conError => {
                if (conError.index === conIndex) {
                  return { ...conError, max: 'Please Enter Max Value Greater Than Min Value' }
                } else {
                  return conError
                }
              })
            }
          } else if (parseFloat(con.max) > 720) {
            pbh_condition_error = pbh_condition_error.map(conError => {
              if (conError.index === conIndex) {
                return { ...conError, max: `Maximum ${con.type === 1 ? `Flight` : `Block`} Hours Allowed Per Month is 720` }
              } else {
                return conError
              }
            })
          }
        }
      })
    }
    if (leaseRental.rental_type !== 3 && leaseRental.rental_type !== 4 && leaseRental.rental_type !== 5) {
      delete leaseRental.pbh_condition
      delete leaseRental.unit_of_measure
    } else {
      let pbhs = []
      let unitMeasure = {
        1: '_fh',
        2: '_fc',
        3: '_bh'
      }
      leaseRental.pbh_condition.map(rental => {
        pbhs.push({
          type: rental.type,
          min_fh: rental.min,
          max_fh: rental.max,
          rental_rate_type: rental.rental_rate_type,
          rate: rental.rate
        })
      })
    }
    // if(leaseRental.rental_type == 3){
    // let validIntervalArray=this.checkChildIntervalMap();
    // }
    if (leaseRental.rental_type == 2) {
      if (this.state.sheetInfo && this.state.sheetInfo.length > 0) {
        validArray = this.checkmap();
      } else {
        toastFlashMessage('Please attach the payment sheet', 'error');
        return;
      }
    }
    let pbhMinMaxErrFlag = false
    if([3,5].includes(leaseRental?.rental_type) && leaseRental?.unit_of_measure && Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' })) {
      if([3,5].includes(leaseRental?.unit_of_measure)){
        let pbhFilterarr =leaseRental.pbh_condition.filter(item=> {return ( (item?.type ==1 && (item?.ratio_range == '1' ||  item?.ratio_range == '6')) || (item?.type ==2 &&(item?.ratio_range == '1' ||  item?.ratio_range == '6')) )})
        if(pbhFilterarr.length < 4 ){
          pbhMinMaxErrFlag =true
          toastFlashMessage("Please input Min and Max Range Conditions to save.", 'error');
        }
      }
      else{
        let pbhFilterarr =leaseRental.pbh_condition.filter(item=> {return (item?.ratio_range == '1' ||  item?.ratio_range == '6')})
        if(pbhFilterarr.length < 2 ){
          pbhMinMaxErrFlag =true
          toastFlashMessage("Please input Min and Max Range Conditions to save.", 'error');
        }
      }
    }
    if(gaTelesisInstance && leaseRental.rental_type == 6){
      validateNewInput={
        ...validateNewInput,
          monthly_rate:leaseRental?.titan_extra_fields?.monthly_rate? '': 'Please enter monthly rate',
          // rental_month: leaseRental.titan_extra_fields?.rates_per_30_days?'':leaseRental.titan_extra_fields?.rental_month? '': 'Please select month'
      }
    }
    if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' }) && !pbhMinMaxErrFlag) {

      if (leaseRental.rental_type == 2) {
        if ((validArray.filter(item => !(item.period && item.payment_date && item.reference_value && item.rent))).length == 0) {
          this.updateRentalCustomLease();
        } else {
          this.setState({
            validationArray: validArray
          });
        }
      } else {
        if (pbh_condition_error.filter(conError => conError.min !== '' || conError.max !== '').length) {
          this.setState({
            error: validateNewInput,
            pbh_condition_error: pbh_condition_error
          });
        } else {
          this.props.addEditLeaseRental(this.state.leaseRental, this.props.type);
        }
      }
    } else {
      this.setState({
        error: validateNewInput,
        pbh_condition_error: pbh_condition_error
      });
    }
  }
  checkChildIntervalMap = () => {
    let vaildArray = [];
    this.state.leaseRental.pbh_condition.map((interval, index) => {
      let obj = {};
      if (interval.remarks.includes('min')) {
        if ((checkNumber({ value: interval.min, required: true, minLength: '', maxLength: '', message: 'Please Enter Min ratio' })) == '') {
          obj.min = true;
        } else {
          obj.min = false;
        }
      } else {
        obj.min = true
      }
      if ((checkString({ value: interval.ratio_range, required: true, minLength: '', maxLength: '', message: 'Please Enter Ratio Range' })) == '') {
        obj.ratio_range = true;
      } else {
        obj.ratio_range = false;
      }
      if (interval.remarks.includes('max')) {
        if ((checkNumber({ value: interval.max, required: true, minLength: '', maxLength: '', message: 'Please Enter Max Ratio' })) == '') {
          obj.max = true;
        } else {
          obj.max = false;
        }
      } else {
        obj.max = true;
      }
      if ((checkNumber({ value: interval.min, required: true, minLength: '', maxLength: '', message: 'Please Enter Min ratio' })) == '' &&
        (checkNumber({ value: interval.max, required: true, minLength: '', maxLength: '', message: 'Please Enter Max Ratio' })) == '' &&
        (checkString({ value: interval.ratio_range, required: true, minLength: '', maxLength: '', message: 'Please Enter Ratio Range' })) == '') {
        if (this.checkValidationRatio(interval.min, interval.max, interval.ratio_range)) {
          obj.ratio_range_validation = true;
        } else {
          obj.ratio_range_validation = false;
        }
      } else {
        obj.ratio_range_validation = true;
      }
      vaildArray.push(obj)
    })
    return vaildArray;
  }

  getImportResponseBack = (response, responseKey) => {
    const typesToReplace = response?.map(item => item.type);
    const filteredArray1 = this.state.leaseRental && this.state.leaseRental[responseKey]?.filter(item => !typesToReplace.includes(item.type));
    const updatedArray = [...filteredArray1, ...response];
    this.setState(prevState => ({
      ...prevState,
      leaseRental: {
        ...prevState.leaseRental,
        [responseKey]: updatedArray
      }
    }))
  }

  exportTable = (tableData, type, fileName, ratioType) => {
    const updatedTableData = tableData?.length > 0 ? ratioType ? tableData?.filter((filterData) => filterData?.type === ratioType) : tableData : []
    const payload = {
      "data": updatedTableData,
      "type": type,
      "download": "xlsx"
    }
    globalDownloadService(`/contracts/${this.props.params.contract_slug}/export_reserve_rates_table/`, payload)
      .then(response => { 
        downloadFileType(response?.data, `${fileName}_${moment(new Date()).format("DD-MM-YYYY")}`, 'xlsx') 
        if(response?.data){
          toastFlashMessage(updatedTableData?.length ? "File exported successfully" : "Sample file exported successfully.", 'success');
        }
      })
  }
   
  render() {
    const { leaseRental, error,  leaseRentalLoader, pbh_condition_error, accType, assetList} = this.state;
    const { type } = this.props;
    console.log('leaseRental',leaseRental)
    let assetType =this.props.rentalInfoDetails.contract_rental_details.asset_type
    const importNote = leaseRental?.id ? "Kindly note that importing the file during Edit will replace the existing data with the new values." : ""
    return (
      <form onSubmit={(e) => this.updateRental(e)}>
        <div style={{ height: (window.innerHeight - 157) + 'px', overflow: 'auto', marginBottom: '60px' }}>
          <Row>
            {jetStreamInstance ?<>
            <FieldCol md="12">
                <FieldGroup className="form-group">
                <span style={{ fontWeight: leaseRental?.rental_invoice_type?.value === 1 ? "600" : "400", color: leaseRental?.rental_invoice_type?.value === 1 ? "#04049e" : "#888", fontFamily: leaseRental?.rental_invoice_type?.value === 1 ? 'Conv_IBMPlexSans-Bold' : 'Conv_IBMPlexSans-Regular' }}>
                  Advance
                </span>
                <Switch
                  checked={leaseRental?.rental_invoice_type?.value === 2}
                  onChange={(e) => this.updateForm( "rental_invoice_type", e.target.checked ? { value: 2, label: "Arrear" } : { value: 1, label: "Advance" } ) }
                  color="primary"
                  disabled={type === 'view'}
                />
                <span style={{ fontWeight: leaseRental?.rental_invoice_type?.value === 2 ? "600" : "400", color: leaseRental?.rental_invoice_type?.value === 2 ? "#04049e" : "#888" ,fontFamily: leaseRental?.rental_invoice_type?.value === 2 ? 'Conv_IBMPlexSans-Bold' : 'Conv_IBMPlexSans-Regular' }}>
                  Arrear
                </span>
                </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label"> Rental Account Name {type != 'view' ? <sup className="reqStar"> * </sup> : null} </FieldLabel>
                <FieldInput
                  value={leaseRental?.rental_rate_name}
                  type={type}
                  maxLength={50}
                  keyParam="rental_rate_name"
                  updateField={this.updateForm}
                />
                <h6 className="error-msg">{error.rental_rate_name}</h6>
              </FieldGroup>
            </FieldCol> </>: null }
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={true}>Rental Currency</FieldLabel>
                <FieldSelect
                  placeholder='Select Rental Currency'
                  keyParam="currency"
                  value={leaseRental.currency}
                  type={type}
                  options={currencyList}
                  updateField={this.updateForm}
                  labelKey='label'
                  valueKey='value'
                  name={Object.keys(leaseRental).length && type != 'add' ? this.props.rentalView.currency.label : ''}
                />
                <h6 className="error-msg">{error.currency}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={true}>Rental Type</FieldLabel>
                <FieldSelect
                  placeholder='Select Rental Type'
                  keyParam="rental_type"
                  value={leaseRental.rental_type}
                  type={type}
                  options={gaTelesisInstance?[...rentalTypeDropdown,{value: 6, label: 'Prorated'}]: rentalTypeDropdown}
                  updateField={this.updateForm}
                  labelKey='label'
                  valueKey='value'
                  name={Object.keys(leaseRental).length && type != 'add' ? this.props.rentalView.rental_type.label : ''}
                />
                <h6 className="error-msg">{error.rental_type}</h6>

              </FieldGroup>
            </FieldCol>
            {gaTelesisInstance && leaseRental.rental_type == 6 ?<>
             
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label" required={true}>Rate (USD) per Month</FieldLabel>
                  <FieldInput
                    value={leaseRental.titan_extra_fields?.monthly_rate}
                    type={type}
                    keyParam="monthly_rate" 
                    updateField={this.updateTitanFields}
                  />
                  <h6 className="error-msg">{error.monthly_rate}</h6>

                </FieldGroup>
              </FieldCol>
              <FieldCol md='6'>
              <FieldGroup className='form-group'>
              <FieldLabel className="label">Rental rate per </FieldLabel>
              <FieldLabel className="label" style={{ display: 'block' }}>
                      <span ><input onClick={(e) => type !== 'view' ? this.updateTitanFields('rates_per_30_days', true) : null} disabled={type === 'view' ? true : false} style={{ marginRight: '5px', cursor:'pointer' }} checked={leaseRental.titan_extra_fields?.rates_per_30_days === true} type="radio" />30 Days</span>
                      <span onClick={(e) => e.preventDefault()} style={{ marginLeft: '20px'}}><input  onClick={(e) => { e.stopPropagation(); if (type !== 'view') { this.updateTitanFields('rates_per_30_days', false); }}} disabled={type === 'view' ? true : false} style={{ marginRight: '5px', cursor:'pointer' }} checked={leaseRental.titan_extra_fields?.rates_per_30_days === false} type="radio" />Days in rental month</span> 
                    </FieldLabel>
              </FieldGroup>
            </FieldCol>
            {/* {leaseRental.titan_extra_fields?.rates_per_30_days ?null:
              <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={true}>Rental month to be invoiced </FieldLabel>
                <FieldSelect
                  placeholder='Select month'
                  keyParam="rental_month"
                  value={leaseRental.titan_extra_fields?.rental_month}
                  type={type}
                  options={months}
                  updateField={this.updateTitanFields}
                  labelKey='label'
                  valueKey='value'
                  name={leaseRental?.titan_extra_fields?.rental_month || '--'}
                />
                <h6 className="error-msg">{error?.rental_month}</h6>
              </FieldGroup>
            </FieldCol>} */}
            {leaseRental?.titan_extra_fields?.rates_per_30_days ?
            <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label" >Rental Rate per day</FieldLabel>
                  <FieldInput
                    value={leaseRental.titan_extra_fields?.rental_rate_per_day}
                    type={type}
                    disable={true}
                    keyParam="rental_rate_per_day"
                    updateField={this.updateTitanFields}
                  />
                  <h6 className="error-msg">{error.rental_rate_per_day}</h6>

                </FieldGroup>
              </FieldCol>: null}
            </>
               : null}
               {titanInstance &&  <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Lease Extension Rent</FieldLabel>
                  <FieldInput
                    value={leaseRental?.titan_extra_fields?.lease_extention_rent}
                    type={type}
                    keyParam="lease_extention_rent"
                    updateField={this.updateTitanFields}
                  />
                </FieldGroup>
              </FieldCol> }  
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={true}>Rental Start Date</FieldLabel>
                {gaTelesisInstance && leaseRental.rental_type == 6 ?
                  <FieldDate
                    value={leaseRental?.titan_extra_fields?.rental_start_date}
                    type={type}
                    keyParam="rental_start_date"
                    updateField={this.updateTitanFields}
                    minDate={this.props.rentalInfoDetails?.contract_rental_details?.contractual_start_date ? moment(this.props.rentalInfoDetails?.contract_rental_details?.contractual_start_date) : null}
                  /> :
                  <FieldDate
                    value={leaseRental.start_date}
                    type={type}
                    keyParam="start_date"
                    updateField={this.updateForm}
                    minDate={this.props.rentalInfoDetails?.contract_rental_details?.contractual_start_date ? moment(this.props.rentalInfoDetails?.contract_rental_details?.contractual_start_date) : null}
                  />}
                <h6 className="error-msg">{error.start_date}</h6>

              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={ this.props.rentalInfoDetails.contract_rental_details?.lease_duration_type?.value != 3 ?true:false}>Rental End Date</FieldLabel>
                {gaTelesisInstance && leaseRental.rental_type == 6 ?
                <FieldDate
                value={leaseRental?.titan_extra_fields?.rental_end_date}
                type={type}
                keyParam="rental_end_date"
                updateField={this.updateTitanFields}
                minDate={leaseRental.titan_extra_fields?.rental_start_date ? moment(leaseRental.titan_extra_fields?.rental_start_date) : moment()}
                maxDate={ this.props.rentalInfoDetails.contract_rental_details?.lease_duration_type?.value != 1? null : moment(this.props.rentalInfoDetails.contract_rental_details?.contractual_end_date)}
              />:
                <FieldDate
                  value={leaseRental.end_date}
                  type={type}
                  keyParam="end_date"
                  updateField={this.updateForm}
                  minDate={leaseRental.start_date ? moment(leaseRental.start_date).add(1, 'day') : moment()}
                  maxDate={ this.props.rentalInfoDetails.contract_rental_details?.lease_duration_type?.value != 1? null : moment(this.props.rentalInfoDetails.contract_rental_details?.contractual_end_date)}
                />}
                <h6 className="error-msg">{error.end_date}</h6>

              </FieldGroup>
            </FieldCol>
            {gaTelesisInstance && leaseRental.rental_type == 6 ?<>
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Number of Rental days</FieldLabel>
                  <FieldInput
                    value={leaseRental.titan_extra_fields?.no_of_days}
                    type={type}
                    disable={true}
                    keyParam="no_of_days"
                  />
                </FieldGroup>
              </FieldCol>
              {leaseRental?.titan_extra_fields?.rates_per_30_days ?
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Prorated Rental Amount</FieldLabel>
                  <FieldInput
                    value={leaseRental?.titan_extra_fields?.prorated_rental_amount}
                    type={type}
                    disable={true}
                    keyParam="prorated_rental_amount"
                  />

                </FieldGroup>
              </FieldCol>:null}
             </>:null}
            {jetStreamInstance?<>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Account Type
                  {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                </FieldLabel>
                <FieldSelect
                  placeholder='Select Account Type'
                  keyParam="account_type"
                  value={leaseRental?.account_type ? leaseRental?.account_type:0}
                  type={type}
                  options={assetType && assetType == 1 || assetType == 2 ? accType.filter(i => (i.value !== 3 || jetStreamInstance)) : accType.filter(i => i.value !== 1 && (i.value !== 3 || jetStreamInstance))}
                  updateField={(type, value) => this.updateForm(type, accType.find(acItem => acItem.value == value))}
                  labelKey='label'
                  valueKey='value'
                  name={leaseRental.account_type && leaseRental.account_type.label ? leaseRental.account_type.label : ''}

                />
                <h6 className="error-msg">{error.account_type}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={type != 'view'?true:false}> Chart Of Account</FieldLabel>
                <FieldSelect
                  placeholder="Select Chart Of Account"
                  keyParam="qb_chart_of_account"
                  value={leaseRental?.qb_chart_of_account?.id}
                  type={type}
                  options={[ ...(this.props.chartAccInfo?.map(item => ({ label: item?.name, value: item?.id, })) || []), ...(!this.props.chartAccInfo?.some( item => item?.id === leaseRental?.qb_chart_of_account?.id ) && leaseRental?.qb_chart_of_account ? [{ label: leaseRental?.qb_chart_of_account.name, value: leaseRental?.qb_chart_of_account.id, }] : []) ]}                  
                  updateField={(type, value) =>this.updateForm(type, this.props.chartAccInfo.find(acItem => acItem.id == value))}                  
                  labelKey="label"
                  valueKey="value"
                  name={leaseRental?.qb_chart_of_account?.name||'--'}
                />
                <h6 className="error-msg">{error.qb_chart_of_account}</h6>
                {type!=='view'?<Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by : {" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {this.props.chartAccInfo?.[0]?.qb_last_sync_by?.name ? `${this.props.chartAccInfo?.[0].qb_last_sync_by.name} (${this.props.chartAccInfo?.[0].qb_last_sync_time ? moment(this.props.chartAccInfo?.[0].qb_last_sync_time).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>:null}
              </FieldGroup>
            </FieldCol>
             <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Asset
                  {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                </FieldLabel>
                {['add', 'edit'].includes(type) ?
                <FieldSelect
                  placeholder='Select Asset'
                  keyParam="major_assembly"
                  value={leaseRental.major_assembly}
                  type={type}
                  options={assetList }
                  updateField={this.updateForm}
                  labelKey='name'
                  valueKey='id'
                /> :
                <FieldInput value={(this.props.utilsMajorAssembly.find(assembly => assembly.asset_id == leaseRental?.asset_id)?.name)} type={type} />}
                <h6 className="error-msg">{error.major_assembly}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={type != 'view'?true:false}>Product And Service</FieldLabel>
                <FieldSelect
                  placeholder="Select Product And Service"
                  keyParam="qb_product_and_service"
                  value={leaseRental?.qb_product_and_service?.id}
                  type={type}
                  options={[ ...(this.props.productServiceInfo?.map(item => ({ label: item?.name, value: item?.id, })) || []), ...(!this.props.productServiceInfo?.some( item => item?.id === leaseRental?.qb_product_and_service?.id ) && leaseRental?.qb_product_and_service ? [{ label: leaseRental?.qb_product_and_service.name, value: leaseRental?.qb_product_and_service.id, }] : []) ]}                  
                  updateField={(type, value) =>this.updateForm(type, this.props.productServiceInfo.find(acItem => acItem.id == value))}                  
                  labelKey="label"
                  valueKey="value"
                  name={leaseRental?.qb_product_and_service?.name||'--'}
                />
                <h6 className="error-msg">{error.qb_product_and_service}</h6>
                {type!=='view'?<Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by : {" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {this.props.productServiceInfo?.[0]?.qb_last_sync_by?.name ? `${this.props.productServiceInfo?.[0].qb_last_sync_by.name} (${this.props.productServiceInfo?.[0].qb_last_sync_time ? moment(this.props.productServiceInfo?.[0].qb_last_sync_time).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>:null}
              </FieldGroup>
              </FieldCol>  </>:null}
          </Row>
          {
            leaseRental.rental_type === 3 || leaseRental.rental_type === 6 ?
              <Row>
                <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Escalation Interval</FieldLabel>
                    <FieldSelect
                      placeholder='Select Escalation Interval'
                      keyParam="escalation_interval"
                      value={leaseRental.escalation_interval}
                      type={type}
                      options={escalationIntervalDropdwn}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                      name={Object.keys(leaseRental).length && type != 'add' ? this.props.rentalView.escalation_interval.label : ''}
                    />
                  </FieldGroup>
                </FieldCol>
                <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Escalation (%)</FieldLabel>
                    <FieldInput
                      value={leaseRental.escalation_percentage}
                      type={type}
                      keyParam="escalation_percentage"
                      updateField={this.updateForm}
                    />
                  </FieldGroup>
                </FieldCol>
                <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Escalation Start Date</FieldLabel>
                    <FieldDate
                      value={leaseRental.escalation_start_date}
                      type={type}
                      keyParam="escalation_start_date"
                      updateField={this.updateForm}
                      minDate={leaseRental.start_date ? moment(leaseRental.start_date) : moment()}
                      maxDate={leaseRental.end_date ? moment(leaseRental.end_date) : moment()}
                    />
                    <h6 className="error-msg">{error.escalation_start_date}</h6>
                  </FieldGroup>
                </FieldCol>
                {gaTelesisInstance || Lessor_test ?
                  <FieldCol md="6">
                    <FieldGroup className="form-group">
                      <FieldLabel className="label">Escalated Rounding Rate</FieldLabel>
                      <FieldSelect
                        placeholder='Select Escalated Rounding Rate'
                        keyParam="round_off_escalation"
                        value={leaseRental.round_off_escalation || '--'}
                        type={type}
                        options={roundOffTypes}
                        updateField={(key, value) => this.updateForm(key, value ? value : null)}
                        labelKey='label'
                        valueKey='value'
                        name={leaseRental?.round_off_escalation?.label || '--'}
                      />
                    </FieldGroup>
                  </FieldCol> : null}
              </Row>
              : null
          }
          <Row>
            {
              leaseRental.rental_type === 3 || leaseRental.rental_type === 4 || leaseRental.rental_type === 5 ?
                <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label" required={true}>Unit Of Measure</FieldLabel>
                    {
                      type != 'view' ?
                        <Select
                          name="form-field-name"
                          placeholder="Select Unit Of Measure"
                          className="custom-select-block"
                          value={leaseRental.unit_of_measure}
                          disabled={leaseRental.rental_type === 5}
                          options={leaseRental.rental_type === 5 ? [
                            {
                              id: 5,
                              label: 'Flight Hours and Flight Cycles'
                            }
                          ] : [
                            {
                              id: 1,
                              label: 'Flight Hour'
                            },
                            {
                              id: 2,
                              label: 'Flight Cycle'
                            },
                            {
                              id: 4,
                              label: 'Block Hour'
                            },
                            {
                              id: 3,
                              label: 'Whichever is Greater'
                            },
                          ]}
                          labelKey="label"
                          valueKey="id"
                          type={type}
                          onChange={(target) => this.updateForm('unit_of_measure', target && target.id ? target.id : '')}
                        /> :
                        <h6>{leaseRental.unit_of_measure ? { 1: 'Flight Hour', 2: 'Flight Cycle', 3: 'Whichever is Greater', 4: 'Block Hour', 5: 'Flight Hours and Flight Cycles' }[leaseRental.unit_of_measure] : '--'}</h6>
                    }
                    <h6 className="error-msg">{error.unit_of_measure}</h6>
                  </FieldGroup>
                </FieldCol>
                : null
            }
            {
              leaseRental.rental_type === 3 || leaseRental.rental_type === 5 ?
                <FieldCol md="12">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label" required={true}>Range Condition To Be Considered</FieldLabel>
                    <FieldLabel className="label" style={{ display: 'block' }}>
                      <span onClick={() => type !== 'view' ? this.updateForm('range_calculation_type', false) : null} style={{ cursor: 'pointer' }}><input disabled={type === 'view' ? true : false} style={{ marginRight: '5px' }} checked={leaseRental.range_calculation_type === false} type="radio" />Either Off</span>
                      <span onClick={() => type !== 'view' ? this.updateForm('range_calculation_type', true) : null} style={{ marginLeft: '20px', cursor: 'pointer' }}><input disabled={type === 'view' ? true : false} style={{ marginRight: '5px' }} checked={leaseRental.range_calculation_type === true} type="radio" />All</span>
                    </FieldLabel>
                  </FieldGroup>
                </FieldCol>
                : null
            }
            {
              leaseRental.rental_type === 3 || leaseRental.rental_type === 5 ?
                leaseRental.unit_of_measure === 1 || leaseRental.unit_of_measure === 3 || leaseRental.unit_of_measure === 5 ?
                  <Col md="12"  >
                    <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between", 
                      marginRight: "25px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px', marginTop: '0px' }}>Flight Hour</h3>
                      <div>
                        {type != 'view' ?
                          <ImportModal
                            url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                            rateType="pbh_status"
                            responseKey="pbh_condition"
                            importNote={importNote}
                            ratioType={"flight_hour"}
                            getResponseBack={this.getImportResponseBack}
                            onSampleExport={()=>this.exportTable([], "pbh_status",'Flight_Hour_Sample')} 
                          /> : null}
                        <CustomExportButton
                          disabled={this.state.leaseRental?.pbh_condition?.length === 0}
                          handleExport={() => this.exportTable(this.state.leaseRental?.pbh_condition, "pbh_status", 'Flight_Hour',1 || 4)} />
                        <img alt="infoIcon" src={imgStoragePath + 'inv_info_icon.png'} id='flight_hour_pbh' onClick={() => this.setState({ flight_hour_pbh: !this.state.flight_hour_pbh })} style={{ width: '15px', position: 'reset',cursor : 'pointer' }} />
                      </div>
                    </div>
                    {
                      this.type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.flight_hour_pbh} target="flight_hour_pbh" toggle={() => this.setState({ flight_hour_pbh: !this.state.flight_hour_pbh })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            leaseRental.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 1 || rCondition.type === 4 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].max}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>
                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}

                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removeRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 1 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 1 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    {
                      leaseRental.rental_type !== 5 ?
                        <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_condition}</h6></div>
                        : null
                    }
                  </Col>
                  : null
                : null
            }
            {
              leaseRental.rental_type === 3 || leaseRental.rental_type === 5 ?
                leaseRental.unit_of_measure === 2 || leaseRental.unit_of_measure === 3 || leaseRental.unit_of_measure === 5 ?
                  <Col md="12"  >
                    <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between",
                      marginRight: "25px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px',marginTop : "0px"  }}>Flight Cycles</h3>
                      <div>
                        {type != 'view' ?
                          <ImportModal
                            url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                            rateType="pbh_status"
                            responseKey="pbh_condition"
                            importNote={importNote}
                            ratioType={"flight_cycle"}
                            getResponseBack={this.getImportResponseBack}
                            onSampleExport={() => this.exportTable([], "pbh_status", 'Flight_Cycles_Sample')}
                          /> : null}
                        <CustomExportButton
                          disabled={this.state.leaseRental?.pbh_condition?.length === 0}
                          handleExport={() => this.exportTable(this.state.leaseRental?.pbh_condition, "pbh_status", 'Flight_Cycles', 2)} />
                        <img alt="infoIcon" src={imgStoragePath + 'inv_info_icon.png'} id='flight_cycle_pbh' onClick={() => this.setState({ flight_cycle_pbh: !this.state.flight_cycle_pbh })} style={{ width: '15px', position: 'reset',cursor : 'pointer' }} />
                      </div>
                    </div>
                 
                    {
                      type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.flight_cycle_pbh} target="flight_cycle_pbh" toggle={() => this.setState({ flight_cycle_pbh: !this.state.flight_cycle_pbh })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            leaseRental.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 2 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => (intRegx.test(evt.target.value) && evt.target.value >= 0) || evt.target.value == '' ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => (intRegx.test(evt.target.value) && evt.target.value >= 0) || evt.target.value == '' ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].max}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>
                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => rCondition.rate <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}
                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removeRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 2 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 2 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_condition}</h6></div>
                  </Col>
                  : null
                : null
            }
            {
              leaseRental.rental_type === 3 ?
                leaseRental.unit_of_measure === 4 ?
                  <Col md="12"  >
                    <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between",
                      marginRight: "25px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px', marginTop: '0px' }}>Block Hours</h3>
                      <div>
                        {type != 'view' ?
                          <ImportModal
                            url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                            rateType="pbh_status"
                            responseKey="pbh_condition"
                            importNote={importNote}
                            ratioType={"block_hour"}
                            getResponseBack={this.getImportResponseBack}
                            onSampleExport={() => this.exportTable([], "pbh_status", 'Block_Hours_Sample')}
                          /> : null}
                        <CustomExportButton
                          disabled={this.state.leaseRental?.pbh_condition?.length === 0}
                          handleExport={() => this.exportTable(this.state.leaseRental?.pbh_condition, "pbh_status", 'Block_Hour',4)} />
                        <img alt="Info Icon" src={imgStoragePath + 'inv_info_icon.png'} id='block_hour_pbh' onClick={() => this.setState({ block_hour_pbh: !this.state.block_hour_pbh })} style={{ width: '15px', position: 'reset',cursor : 'pointer' }} />
                      </div>
                    </div>
                    {
                      type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.block_hour_pbh} target="block_hour_pbh" toggle={() => this.setState({ block_hour_pbh: !this.state.block_hour_pbh })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            leaseRental.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 4 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].max}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>

                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => rCondition.rate <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}
                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removeRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 4 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(4, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 4 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(4, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(4, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_condition}</h6></div>
                  </Col>
                  : null
                : null
            }
            {
              leaseRental.rental_type === 4 ?
                leaseRental.unit_of_measure === 1 || leaseRental.unit_of_measure === 3 ?
                  <Col md="12"  >
                     <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between", 
                      marginRight: "25px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px', marginTop: '0px' }}>Flight Hour</h3>
                      <div>
                        {type != 'view' ?
                          <ImportModal
                            url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                            rateType="pbh_status"
                            responseKey="pbh_condition"
                            importNote={importNote}
                            ratioType={"flight_hour"}
                            getResponseBack={this.getImportResponseBack}
                            onSampleExport={()=>this.exportTable([], "pbh_status",'Flight_Hour_Sample')} 
                          /> : null}
                        <CustomExportButton
                          disabled={this.state.leaseRental?.pbh_condition?.length === 0}
                          handleExport={() => this.exportTable(this.state.leaseRental?.pbh_condition, "pbh_status", 'Flight_Hour',1 || 4)} />
                       <img alt="InfoIcon"  src={imgStoragePath + 'inv_info_icon.png'} id='flight_hour_flexi' onClick={() => this.setState({ flight_hour_flexi: !this.state.flight_hour_flexi })} style={{ width: '15px', position: 'reset',cursor : 'pointer' }} />
                      </div>
                    </div>
                    {/* <h3 style={{ borderBottom: 'none', marginBottom: '0px' }}>Flight Hour </h3> */}
                    {
                      type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.flight_hour_flexi} target="flight_hour_flexi" toggle={() => this.setState({ flight_hour_flexi: !this.state.flight_hour_flexi })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            leaseRental.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 1 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          disabled={rCondition.ratio_range !== '4'}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>

                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => parseInt(rCondition.rate) <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}
                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removeRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 1 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 1 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_condition}</h6></div>
                  </Col>
                  : null
                : null
            }
            {
              leaseRental.rental_type === 4 ?
                leaseRental.unit_of_measure === 2 || leaseRental.unit_of_measure === 3 ?
                  <Col md="12"  >
                    <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between",
                      marginRight: "25px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px' ,marginTop : "0px" }}>Flight Cycles </h3>
                      <div>
                        {type != 'view' ?
                          <ImportModal
                            url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                            rateType="pbh_status"
                            responseKey="pbh_condition"
                            importNote={importNote}
                            ratioType={"flight_cycle"}
                            getResponseBack={this.getImportResponseBack}
                            onSampleExport={() => this.exportTable([], "pbh_status", 'Flight_Cycles_Sample')}
                          /> : null}
                        <CustomExportButton
                          disabled={this.state.leaseRental?.pbh_condition?.length === 0}
                          handleExport={() => this.exportTable(this.state.leaseRental?.pbh_condition, "pbh_status", 'Flight_Cycles', 2)} />
                        <img alt="infoIcon" src={imgStoragePath + 'inv_info_icon.png'} id='flight_cycle_flexi' onClick={() => this.setState({ flight_cycle_flexi: !this.state.flight_cycle_flexi })} style={{ width: '15px', position: 'reset',cursor : 'pointer' }} />
                      </div>
                    </div>
                    {
                      type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.flight_cycle_flexi} target="flight_cycle_flexi" toggle={() => this.setState({ flight_cycle_flexi: !this.state.flight_cycle_flexi })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            leaseRental.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 2 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => (intRegx.test(evt.target.value) && evt.target.value >= 0) || evt.target.value == '' ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => (intRegx.test(evt.target.value) && evt.target.value >= 0) || evt.target.value == '' ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].max}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          disabled={rCondition.ratio_range !== '4'}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>

                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => parseInt(rCondition.rate) <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}
                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removeRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 2 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 2 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_condition}</h6></div>
                  </Col>
                  : null
                : null
            }
            {
              leaseRental.rental_type === 4 ?
                leaseRental.unit_of_measure === 4 ?
                  <Col md="12"  >
                    <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between",
                      marginRight: "25px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px', marginTop: '0px' }}>Block Hours </h3>
                      <div>
                        {type != 'view' ?
                          <ImportModal
                            url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                            rateType="pbh_status"
                            responseKey="pbh_condition"
                            importNote={importNote}
                            ratioType={"block_hour"}
                            getResponseBack={this.getImportResponseBack}
                            onSampleExport={() => this.exportTable([], "pbh_status", 'Block_Hours_Sample')}
                          /> : null}
                        <CustomExportButton
                          disabled={this.state.leaseRental?.pbh_condition?.length === 0}
                          handleExport={() => this.exportTable(this.state.leaseRental?.pbh_condition, "pbh_status", 'Block_Hour',4)} />
                        <img alt="infoIcon" src={imgStoragePath + 'inv_info_icon.png'} id='block_hour_flexi' onClick={() => this.setState({ block_hour_flexi: !this.state.block_hour_flexi })} style={{ width: '15px', position: 'reset',cursor : 'pointer' }} />
                      </div>
                    </div>
                    {
                      type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.block_hour_flexi} target="block_hour_flexi" toggle={() => this.setState({ block_hour_flexi: !this.state.block_hour_flexi })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            leaseRental.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 4 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.ratio_range == 6 ? rCondition.max?.length > 0 ? rCondition.max : ' NA' : rCondition.max}</h6>
                                    }
                                    {
                                      !leaseRentalLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].max}</h6> : null
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          disabled={rCondition.ratio_range !== '4'}
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>

                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => parseInt(rCondition.rate) <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}
                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removeRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 4 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(4, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && leaseRental.pbh_condition.filter(item => parseInt(item.type) === 4 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(4, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(4, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_condition}</h6></div>
                  </Col>
                  : null
                : null
            }
          </Row>
          {leaseRental.rental_type == 1 ?
            <Row>
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label" required={true}> Interval</FieldLabel>
                  <FieldSelect
                    placeholder='Select  Interval'
                    keyParam="interval"
                    value={leaseRental.interval}
                    type={type}
                    options={jetStreamInstance && leaseRental?.rental_invoice_type?.value === 1 ? intervalDropdown.filter(item => [1, 5].includes(item.value)):leaseRental.rental_type !== 4 ? intervalDropdown.filter(item => item.value !== 4) : intervalDropdown}
                    updateField={this.updateForm}
                    labelKey='label'
                    valueKey='value'
                    name={Object.keys(leaseRental).length && type != 'add' && leaseRental.rental_type==1 ? this.props.rentalView.interval.label : ''}
                  />
                  <h6 className="error-msg">{error.interval}</h6>

                </FieldGroup>
              </FieldCol>

              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label" required={true}>Rate	({leaseRental.currency ? leaseRental.currency : 'USD'})</FieldLabel>
                  <FieldInput
                    value={leaseRental.amount}
                    type={type}
                    keyParam="amount"
                    updateField={this.updateForm}
                    currency={true}
                    currencyType={leaseRental.currency}
                  />
                  <h6 className="error-msg">{error.amount}</h6>

                </FieldGroup>
              </FieldCol>
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Escalation Interval</FieldLabel>
                  <FieldSelect
                    placeholder='Select Escalation Interval'
                    keyParam="escalation_interval"
                    value={leaseRental.escalation_interval}
                    type={type}
                    options={escalationIntervalDropdwn}
                    updateField={this.updateForm}
                    labelKey='label'
                    valueKey='value'
                    name={Object.keys(leaseRental).length && type != 'add' ? this.props.rentalView.escalation_interval.label : ''}
                  />
                </FieldGroup>
              </FieldCol>
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Escalation (%)</FieldLabel>
                  <FieldInput
                    value={leaseRental.escalation_percentage}
                    type={type}
                    keyParam="escalation_percentage"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Escalation Start Date</FieldLabel>
                  <FieldDate
                    value={leaseRental.escalation_start_date}
                    type={type}
                    keyParam="escalation_start_date"
                    updateField={this.updateForm}
                    minDate={leaseRental.start_date ? moment(leaseRental.start_date) : moment()}
                    maxDate={leaseRental.end_date ? moment(leaseRental.end_date) : moment()}
                  />
                  <h6 className="error-msg">{error.escalation_start_date}</h6>
                </FieldGroup>
              </FieldCol>
              {gaTelesisInstance || Lessor_test? 
            <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Escalated Rounding Rate</FieldLabel>
                    <FieldSelect
                      placeholder='Select Escalated Rounding Rate'
                      keyParam="round_off_escalation"
                      value={leaseRental.round_off_escalation || '--'}
                      type={type}
                      options={roundOffTypes}
                      updateField={(key, value) => this.updateForm(key, value ? value : null)}
                      labelKey='label'
                      valueKey='value'
                      name={leaseRental?.round_off_escalation?.label ||'--'}
                    />
                  </FieldGroup>
                </FieldCol>: null}
            </Row>
            : leaseRental.rental_type == 2 ?
              <Row>
                <FieldCol md="12">
                  <FieldGroup className="form-group">
                    <span className="file_attachment" onClick={() => ''}>
                      <img className="img_attachment" src={imgStoragePath + "attachment.png"} alt="img" />
                      {type == 'view' ? 'Payment Schedule' : type == 'add' ? 'Attach Payment Schedule' : 'Reattach Payment Schedule'} {type != 'view' ? <input type="file" onChange={(e) => this.updatePdf(e.target.files[0])} /> : null}
                      {type != 'add' ?
                        <Link target="_blank" style={{ fontSize: '12px' }} to={leaseRental.url}>  <img style={{ width: '15px', marginRight: '1px', marginLeft: '15px' }} src={imgStoragePath + "view_icon_blue.png"} alt="img" /> Export</Link>
                        : null
                      }
                    </span>
                    <div>
                      <span style={{ fontSize: '10px', color: '#909192' }}> {leaseRental.currency == 'USD' ? 'Attachment should contain - Period, Payment Date, Basic Rent, Dollar Reference Value - ' : 'Attachment should contain - Period, Payment Date, Basic Rent - '}
                        <Link target="_blank" to={'https://sparta-aims.ams3.digitaloceanspaces.com/others/static/contracts/payment_schedule_sample.xlsx'}>Sample rent payment schedule for upload</Link>
                      </span>
                    </div>
                    {this.props.sheetLoader ? <p style={{ fontSize: '14px', color: '#000000', marginLeft: '10px' }}>Loading ...</p> : null}
                    {this.state.sheetInfo && this.state.sheetInfo.length > 0 ?
                      <div>
                        {type != 'view' ?
                          <div>
                            <Link className="edit-table-block" onClick={() => this.editPayment()}>
                              {this.state.payToggleState ? <img style={{ width: '12px', marginRight: '5px' }} src={imgStoragePath + "view_icon_blue.png"} alt="img" /> : <img src={imgStoragePath + "icon_editblock.png"} alt="img" />}
                              {this.state.payToggleState ? 'View Payment Schedule' : 'Edit Payment Schedule'}</Link>
                          </div> : null
                        }
                        <div className="contr-table-blk">
                          <div className="table-container">
                            <form>
                              <div className="table-responsive table-height" style={{ height: '250px' }}>
                                <table className="table-sticky common-table">
                                  {leaseRental.currency == 'USD' ?
                                    <CtrTableHd theads={['Period', 'Payment Date', 'Basic Rent (' + leaseRental.currency + ')', 'Dollar Reference Value']} /> :
                                    <CtrTableHd theads={['Period', 'Payment Date', 'Euro Rent (' + leaseRental.currency + ')']} />
                                  }
                                  <tbody>
                                    {
                                      this.state.sheetInfo.map((payment, childIndex) =>
                                        <tr key={childIndex}>
                                          <td>
                                            {/*this.state.payToggleState ? <input type = "text" value={payment.period} onChange = {(e) => this.updateSheetTable('period',e.target.value,childIndex)} /> : payment.period */}
                                            {payment.period > 0 ? payment.period : 0}
                                            {this.state.validationArray.length > 0 ?
                                              this.state.validationArray[childIndex].period == false ?
                                                <h6 className="error-msg">Please enter vaild values</h6> : null : null}
                                          </td>
                                          <td>
                                            <FieldDateIndex
                                              value={payment.payment_date}
                                              type={this.state.payToggleState ? 'edit' : 'view'}
                                              keyParam="payment_date"
                                              updateField={this.updateSheetTable}
                                              index={childIndex}
                                            />
                                            {/*<h6 className="error-msg">{error[childIndex] ? error[childIndex].tsn : null}</h6>*/}
                                            {this.state.validationArray.length > 0 ?
                                              this.state.validationArray[childIndex].payment_date == false ?
                                                <h6 className="error-msg">Please enter vaild values</h6> : null : null}
                                          </td>
                                          <td>
                                            {this.state.payToggleState ? <input type="text" value={payment.rent} onChange={(e) => this.updateSheetTable('rent', e.target.value, childIndex)} /> :
                                              <NumericLabel params={showCurrencyFormat(leaseRental.currency)}>{payment.rent}</NumericLabel>}

                                            {/*<h6 className="error-msg">{ error[childIndex] ?  error[childIndex].csn : null}</h6>*/}
                                            {this.state.validationArray.length > 0 ?
                                              this.state.validationArray[childIndex].rent == false ?
                                                <h6 className="error-msg">Please enter vaild values</h6> : null : null}
                                          </td>
                                          {leaseRental.currency == 'USD' ?
                                            <td>{this.state.payToggleState ? <input type="text" value={payment.reference_value} onChange={(e) => this.updateSheetTable('reference_value', e.target.value, childIndex)} /> :
                                              <NumericLabel params={showCurrencyFormat(leaseRental.currency)}>{payment.reference_value}</NumericLabel>}
                                              {this.state.validationArray.length > 0 ?
                                                this.state.validationArray[childIndex].reference_value == false ?
                                                  <h6 className="error-msg">Please enter vaild values</h6> : null : null}
                                            </td> : null
                                          }
                                        </tr>
                                      )
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div> : null
                    }
                  </FieldGroup>
                </FieldCol>
                <FieldCol md="12">
                  {leaseRental.currency == 'USD' ?
                    <FieldGroup className="form-group">
                      <span className="checkbox-blk">
                        <input checked={leaseRental.is_additional_rate} type="checkbox" onClick={() => type != 'view' ? this.updateForm('is_additional_rate', !leaseRental.is_additional_rate) : ''} />
                        Additional Rent Applicable
                      </span>
                      {/*<p style={{fontSize:'10px',color:'#909192'}}>Formula:(Preceding Month Dollar Reference Value X(Dollar Margin + LIBOR)X Period)</p>*/}
                    </FieldGroup> : null
                  }
                </FieldCol>
                <FieldCol md="6">
                  {leaseRental.currency == 'USD' ? leaseRental.is_additional_rate ?
                    <FieldGroup className="form-group">
                      <FieldLabel className="label">Dollar Margin (%)</FieldLabel>
                      <FieldInput
                        value={leaseRental.margin}
                        type={type}
                        keyParam="margin"
                        updateField={this.updateForm}
                      />
                      <h6 className="error-msg">{error.margin}</h6>
                    </FieldGroup> : null : null
                  }
                </FieldCol>
              </Row> : null
          }
          <Col md="12" className='flex-centered'>
            <div className="form-group" style={{marginLeft:'-14px'}}>
              <label className="label">
                {
                  type != 'view' ?
                  <input type="checkbox" checked={leaseRental?.max_cap_applicable == true?true:false} onChange={(e) => this.updateForm('max_cap_applicable', e.target.checked ? true : false)} /> : null
                }
                <span >
                  Enable Max Cap Amount<Tooltip title='Click here to enable max cap amount.Even Escalated Amount will be resticted to this amount' placement='bottom-start'><Info style={{ fontSize: '14px' }} /></Tooltip> { }
                </span>
              </label>
            </div>
          </Col>
          {leaseRental?.max_cap_applicable == true ?
            <FieldCol md="4">
                <FieldGroup className="form-group" style={{marginLeft:'-14px'}}>
                  <FieldLabel className="label">
                    Enter Max Cap Amount
                  </FieldLabel>
                  <FieldInput
                    value={/^[0-9]*\.?[0-9]*$/.test(leaseRental?.max_cap_amount)? leaseRental?.max_cap_amount :null}
                    type={type}
                    keyParam="max_cap_amount"
                    updateField={this.updateForm}
                    maxLength={10}
                  />
                  <h6 className="error-msg">{error.max_cap_amount}</h6>
                </FieldGroup>
            </FieldCol> : null}
            {(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance)?
                <Row>
                <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Contractual Aggregation Adjustment </FieldLabel>
                  <FieldInput
                    value={leaseRental?.titan_extra_fields?.contractual_aggr_adj}
                    type={type}
                    accept='number'
                    keyParam="contractual_aggr_adj"
                    updateField={(key,value)=>this.updateTitanFields(key,value)}
                  />
                </FieldGroup>
              </FieldCol>
                <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Rent Schedule Name </FieldLabel>
                  <FieldInput
                    value={leaseRental?.titan_extra_fields?.rent_schedule_name}
                    type={type}
                    keyParam="rent_schedule_name"
                    updateField={(key,value)=>this.updateTitanFields(key,value)}
                  />
                </FieldGroup>
              </FieldCol>
              {avationPlcInstance || mtInstance || leshaBankInstance ?
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Remarks</FieldLabel>
                    <FieldTextarea
                      value={leaseRental?.titan_extra_fields?.rental_remark ? type == 'view' ? (<span dangerouslySetInnerHTML={{ __html: leaseRental?.titan_extra_fields?.rental_remark.replace(/\n/g, '<br />') }} />) : leaseRental?.titan_extra_fields?.rental_remark : ""}
                      type={type}
                      keyParam="rental_remark"
                      updateField={(key,value)=>this.updateTitanFields(key,value)}
                      rows={3}
                    />
                </FieldGroup>
              </FieldCol>:null}
                </Row>:null
              }
              { titanInstance && leaseRental?.rental_type == 1?
              <Row>
                <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Rate	({leaseRental.currency == 'USD' ? 'EUR': 'USD'})</FieldLabel>
                  <FieldInput
                    value={leaseRental?.titan_extra_fields?.alternate_currency}
                    type={type}
                    keyParam="alternate_currency"
                    updateField={this.updateTitanFields}
                    currency={true}
                    currencyType={leaseRental.currency == 'USD' ? 'EUR': 'USD'}
                  />
                </FieldGroup>
              </FieldCol></Row>:null
              }
        </div>
        { type != 'view' ?
          <div className="submit-block">
            <input type="submit" className="primary-btn" value="Save Changes" />
            <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
          </div> : null
        }
      </form>
    )
  }
}
